import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  card: {
    maxWidth: 650,
    width: '100%',
  },
  headerImage: {
    height: 55,
    maxWidth: 388,
    width: '100%',
    marginBottom: 15,
    marginTop: 25,
  },
  formContainer: {
    width: '100%',
    maxWidth: 400,
  },
  paragraph: {
    fontSize: 20,
    marginTop: 25,
    marginBottom: 25,
  },
  subtitle: {
    fontSize: 26,
    fontWeight: 'bold',
  },
  title: {
    fontSize: 80,
    fontWeight: 'bold',
  },

  signUpButton: {
    borderRadius: 15,
    height: 50,
    maxWidth: 400,
    width: '100%',
    marginTop: 10,
  },
  signUpButtonText: {
    fontSize: 24,
  },
  troubleText: {
    fontSize: 16,
    height: '100%',
    marginTop: 40,
  },
  signInButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
  },
  alreadyHaveAnAccount: {
    marginTop: 75,
  },
  signIn: {
    fontSize: 16,
  },
  errorMessage: {
    margin: 10,
    color: 'red',
  }
});
